import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import NervousSystemShift from './components/NervousSystemShift';
import QuickLinks from './components/QuickLinks';
import IdealClient from '../method/components/IdealClient';
import WhereToBegin from '../method/components/WhereToBegin';
import { setPageMeta, injectJsonLd, removeJsonLd } from '../../utils/seo';

const HomePage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || '';
    
    // Set page meta tags
    setPageMeta(
      'Vionne Clinical Atelier | Facial-Led Botanical Acupuncture',
      'Vionne Stability offers premium acupuncture and facial structure regulation services in Vancouver. Specialized nervous system regulation and facial rejuvenation for high-functioning women seeking sustainable wellness.',
      `${siteUrl}/`
    );

    // Inject JSON-LD schema
    const schema = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Vionne Clinical Atelier',
        url: siteUrl,
        description: 'Premium acupuncture and facial structure regulation services for high-functioning women',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string'
        }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        '@id': `${siteUrl}/#business`,
        name: 'Vionne Clinical Atelier',
        image: 'https://public.readdy.ai/ai/img_res/4c425dd554d4d5c449b4649c885ea481.jpg',
        url: siteUrl,
        telephone: '+1-604-XXX-XXXX',
        priceRange: '$$$$',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Vancouver',
          addressLocality: 'Vancouver',
          addressRegion: 'BC',
          postalCode: 'V6B',
          addressCountry: 'CA'
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 49.2827,
          longitude: -123.1207
        },
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '09:00',
            closes: '18:00'
          }
        ],
        sameAs: [
          'https://instagram.com/vionne.stability',
          'https://facebook.com/vionne.stability'
        ]
      }
    ];

    injectJsonLd(schema);

    return () => {
      removeJsonLd();
    };
  }, []);

  return (
    <div className="min-h-screen bg-warmWhite">
      <Navbar />
      <main>
        <HeroSection />
        <NervousSystemShift />
        <IdealClient />
        <WhereToBegin />
        <QuickLinks />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;